
import { Component, Vue } from 'vue-property-decorator';
import NotificationsManager from '@/components/NotificationsManager.vue';
import { readIsLoggedIn } from '@/store/main/getters';
import { dispatchCheckLoggedIn } from '@/store/main/actions';
import { env } from './env';

@Component({
  components: {
    NotificationsManager,
  },
})
export default class App extends Vue {

  get loggedIn() {
    return readIsLoggedIn(this.$store);
  }

  public async created() {
    await dispatchCheckLoggedIn(this.$store);
    this.createGoogleTag();
  }

  // Google tag (gtag.js)
  public createGoogleTag() {
    if (env.toString() === 'production') {
      const script_src = document.createElement('script');
      script_src.src = 'https://www.googletagmanager.com/gtag/js?id=G-0EQMK3D6W8';
      script_src.async = true;
      document.body.appendChild(script_src);

      const script = document.createElement('script');
      script.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-0EQMK3D6W8');
      `;
      document.body.appendChild(script);
    }
  }
}
